// Leave-page guard (GitHub #1, point 2): warn on reload / tab close while
// at least one asset has never been uploaded. "Uploaded" means the asset
// has ≥ 1 COMPLETE version — deliberately NOT "no new work since", because the
// sidebar cannot tell "uploaded, favourites still present" from "edited
// after upload", and warning on every leave would train talents to ignore
// the dialog. Decision 2026-09-14 (docs/decisions.md).
//
// Seit 2026-09-24 (Audit M15) zusätzlich: warnen, solange ein Upload läuft —
// auch ab v2. Ein zugemachter Tab mitten in der Chunk-Phase ließ sonst eine
// halbe Version zurück, die als "Uploaded" durchging.

import { completeVersions, type VersionLike } from './versionStatus';

export function hasUnuploadedAssets(
  assets: ReadonlyArray<{ id: string }>,
  versions: Record<string, ReadonlyArray<VersionLike> | undefined>,
): boolean {
  return assets.some((a) => completeVersions(versions[a.id]).length === 0);
}

/** Läuft gerade irgendwo ein Upload (Sidebar-Spinner `assetBusy`)? */
export function hasUploadInFlight(assetBusy: Record<number, boolean> | undefined): boolean {
  return Object.values(assetBusy ?? {}).some(Boolean);
}

export function shouldWarnBeforeLeave(input: {
  assets: ReadonlyArray<{ id: string }>;
  versions: Record<string, ReadonlyArray<VersionLike> | undefined>;
  assetBusy?: Record<number, boolean>;
}): boolean {
  return hasUploadInFlight(input.assetBusy) || hasUnuploadedAssets(input.assets, input.versions);
}
